import React, { useState } from "react"
import { Form, Table, Row, Col, Pagination } from "react-bootstrap"

function SearchORGResults(props) {
    const [organizationName, setOrganizationName] = useState("")
    const [resultsPerPage, setResultsPerPage] = useState(30)
    const [currentPage, setCurrentPage] = useState(1)
    const indexOfLastResult = currentPage * resultsPerPage
    const indexOfFirstResult = indexOfLastResult - resultsPerPage
    const items = props.results || []
    const currentResult = items.slice(indexOfFirstResult, indexOfLastResult)
    const [activePage, setActivePage] = useState(1)
    
    const handleRadioChange = (e) => {
        const { value } = e.target
        setOrganizationName(value)
        // Pass the organization name string to parent
        props.handler(value)
    }
    
    function handlePageChange(pageNumber) {
        setCurrentPage(pageNumber)
        setActivePage(pageNumber)
    }
    
    const totalPages = Math.ceil(items.length / resultsPerPage)


    const renderPaginationItems = () => {
        const paginationItems = []
        const maxPagesToShow = 3
        let startPage = Math.max(1, activePage - Math.floor(maxPagesToShow / 2))
        let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1)

        if (endPage - startPage + 1 < maxPagesToShow) {
            startPage = Math.max(1, endPage - maxPagesToShow + 1)
        }

        if (activePage > 1) {
            paginationItems.push(
                <Pagination.First key="first" onClick={() => handlePageChange(1)} />,
                <Pagination.Prev key="prev" onClick={() => handlePageChange(activePage - 1)} />
            )
        }

        for (let page = startPage; page <= endPage; page++) {
            paginationItems.push(
                <Pagination.Item
                    key={page}
                    active={page === activePage}
                    onClick={() => handlePageChange(page)}
                >
                    {page}
                </Pagination.Item>
            )
        }

        if (activePage < totalPages) {
            paginationItems.push(
                <Pagination.Next key="next" onClick={() => handlePageChange(activePage + 1)} />,
                <Pagination.Last key="last" onClick={() => handlePageChange(totalPages)} />
            )
        }

        return paginationItems
    }

    const info_content = currentResult.map((key, index) => (
        <tr key={index}>
           <td align="center" width="5%">
                <Form.Check
                    type="radio" 
                    name="tableCheckbox"
                    id={key["name"] || `org-${index}`}
                    value={key["name"] || ""}
                    onChange={handleRadioChange}
                    checked={organizationName === (key["name"] || "")}
                />
            </td>
            <td align="left" width="75%">
                {key["name"] || "N/A"}
            </td>
        </tr>
    ))
    
    return (
        <React.Fragment>
            {items.length === 0 ? (
                <Row>
                    <Col md="12" className="mt-20" align="center">
                        <span 
                            className="reportLabels1" 
                            style={{ color: "#a00505" }}
                        >
                            Search service issue. Please contact SpecReaderExt.im@pg.com for help.
                        </span>
                    </Col>
                </Row>
            ) : (
                <>
                    <div style={{ width: "100%" }} id="paginTab">
                        <Pagination>{renderPaginationItems()}</Pagination>
                    </div>
                    <br />
                    <br />
                    <div className="DSTable">
                        <Table 
                            bordered 
                            className="table-responsive" 
                            style={{justifyContent:"center"}}
                        >
                            <thead id="template_summ_tab">
                                <tr>
                                    <th width="900px">
                                        Name &nbsp;
                                    </th>
                                </tr>
                            </thead>
                            <tbody>{info_content}</tbody>
                        </Table>
                    </div>
                </>
            )}
       </React.Fragment>
    )
}

export default SearchORGResults